import { render, staticRenderFns } from "./LiquidationCard.vue?vue&type=template&id=d4f1de50&scoped=true"
import script from "./LiquidationCard.vue?vue&type=script&lang=js"
export * from "./LiquidationCard.vue?vue&type=script&lang=js"
import style0 from "./LiquidationCard.vue?vue&type=style&index=0&id=d4f1de50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f1de50",
  null
  
)

export default component.exports